module.exports = window.EhsReact.ReactDOM; 